import { createReducer, on } from '@ngrx/store';
import { textWithButtonsFormUpdated } from '../Actions/text-with-buttons.actions';
import { initialTextWithButtonsState } from '../State/text-with-buttons.state';

export const textWithButtonsReducer = createReducer(
  initialTextWithButtonsState,

  on(textWithButtonsFormUpdated, (state, payload) => ({
    ...state,
    formEventChildDataButtonText: { ...payload }
  }))
);
